import { useState, useRef } from 'react'
import { Formik, Field } from 'formik'
import { v4 as uuidv4 } from 'uuid'
import Translation from '../../../Translation/cont/Translation'
import ImageObjDisplayAndUpload from '../ImageObjDisplayAndUpload'
import getTranslationStringById from '../../../Translation/func/getTranslationStringById'

const EditActorsModal = ({ actors, translationStrings, currentLang, onSave, onClose }) => {
    const [expandedRows, setExpandedRows] = useState({})
    const rowsScrollRef = useRef(null)
    const namePlaceholder = getTranslationStringById('movie_edit_movie_actor_name_placeholder', translationStrings, currentLang, 'Name')
    const characterPlaceholder = getTranslationStringById('movie_edit_movie_actor_character_placeholder', translationStrings, currentLang, 'Character')

    const initialRows = actors.length > 0
        ? actors.map(a => ({
            _rowId: uuidv4(),
            name: a.name || '',
            character: a.character || '',
            image: (a.imageURL ? { id: '', format: 'none', alt: a.name || '', url: a.imageURL } : { id: '', format: null, alt: '', url: '' }),
        }))
        : [{ _rowId: uuidv4(), name: '', character: '', image: { id: '', format: null, alt: '', url: '' } }]

    const toggleExpanded = rowId => setExpandedRows(prev => ({ ...prev, [rowId]: !prev[rowId] }))

    return (
        <div className="preview-movie-dialog-overlay" onClick={onClose}>
            <div className="preview-movie-dialog preview-movie-dialog--wide" onClick={e => e.stopPropagation()}>
                <div className="preview-movie-dialog-head">
                    <span className="preview-movie-dialog-title"><Translation id="movie_edit_movie_actors_edit_title" /></span>
                    <button className="preview-movie-dialog-close text-small-regular" type="button" onClick={onClose}>✕</button>
                </div>
                <Formik initialValues={{ rows: initialRows }}>
                    {({ values, setFieldValue }) => (
                        <>
                            <div className="preview-movie-dialog-body">
                                <div className="actor-rows-scroll" ref={rowsScrollRef}>
                                    {values.rows.map((row, index) => (
                                        <div className="actor-row" key={row._rowId}>
                                            <div className="actor-row-main">
                                                <button
                                                    type="button"
                                                    className="actor-thumb"
                                                    onClick={() => toggleExpanded(row._rowId)}
                                                >
                                                    {row.image && row.image.url
                                                        ? <img src={row.image.url} alt={row.name} />
                                                        : <span className="actor-thumb-placeholder" />}
                                                </button>
                                                <input
                                                    className="input-text-box"
                                                    placeholder={namePlaceholder}
                                                    value={row.name}
                                                    onChange={e => setFieldValue(`rows[${index}].name`, e.target.value)}
                                                />
                                                <input
                                                    className="input-text-box"
                                                    placeholder={characterPlaceholder}
                                                    value={row.character}
                                                    onChange={e => setFieldValue(`rows[${index}].character`, e.target.value)}
                                                />
                                                <button
                                                    className="actor-row-remove"
                                                    type="button"
                                                    onClick={() => setFieldValue('rows', values.rows.filter((_, i) => i !== index))}
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                            {expandedRows[row._rowId] && (
                                                <div className="actor-row-upload">
                                                    <Field name={`rows[${index}].image`} component={ImageObjDisplayAndUpload} />
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                                <button
                                    className="button"
                                    type="button"
                                    onClick={() => {
                                        setFieldValue('rows', [...values.rows, { _rowId: uuidv4(), name: '', character: '', image: { id: '', format: null, alt: '', url: '' } }])
                                        requestAnimationFrame(() => {
                                            if (rowsScrollRef.current) {
                                                rowsScrollRef.current.scrollTop = rowsScrollRef.current.scrollHeight
                                            }
                                        })
                                    }}
                                >
                                    <Translation id="add_button" />
                                </button>
                            </div>
                            <div className="preview-movie-dialog-footer">
                                <button className="button button--cancel" type="button" onClick={onClose}>
                                    <Translation id="cancel_button" />
                                </button>
                                <button
                                    className="button"
                                    type="button"
                                    onClick={() => onSave(values.rows
                                        .filter(row => row.name.trim().length > 0)
                                        .map(row => ({
                                            name: row.name.trim(),
                                            character: row.character.trim() || null,
                                            id: null,
                                            imageURL: row.image && row.image.url ? row.image.url : null,
                                        })))}
                                >
                                    <Translation id="save_button" />
                                </button>
                            </div>
                        </>
                    )}
                </Formik>
            </div>
        </div>
    )
}

export default EditActorsModal
